import { useEffect } from 'react';
import { BrowserRouter, useNavigate, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import { isAuthenticated } from './lib/auth';
import { getPublicWebsiteConfig } from './services/api/system';

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const authed = isAuthenticated();

    if (!authed && location.pathname !== '/login') {
      navigate('/login');
    }

    if (authed && location.pathname === '/login') {
      navigate('/');
    }
  }, [navigate, location.pathname]);

  useEffect(() => {
    getPublicWebsiteConfig().then((config) => {
      if (config.site_name) {
        document.title = config.site_name;
      }
    });
  }, []);

  return <AppRoutes />;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
